// removed by extract-text-webpack-plugin
module.exports = {"ArticleList":"src-components-articles----article-list-module---ArticleList---mzL4f","ArticleListItem":"src-components-articles----article-list-module---ArticleListItem---1a426","ArticleListItem__icon":"src-components-articles----article-list-module---ArticleListItem__icon---15KAg","ArticleListItem__name":"src-components-articles----article-list-module---ArticleListItem__name---19DLZ","ArticleListItem__arrow":"src-components-articles----article-list-module---ArticleListItem__arrow---BnorY","spinAround":"src-components-articles----article-list-module---spinAround---3j81c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/articles/article-list.module.scss
// module id = 275
// module chunks = 35783957827783